export default "__VITE_ASSET__3a8ad283__"